import React, { Component } from 'react'
import {TableCell} from 'react-toolbox/lib/table'
import * as R from 'ramda'
import { IconButton } from 'react-toolbox/lib/button'

import Table from 'containers/Manage/Table'

import styles from './styles.scss'

const ActionButton = ({onClickFunc}) =>  <IconButton
      primary
      theme={styles}
      icon='edit'
      onClick={onClickFunc}
      />

const tableHeadContent = Object.freeze({
  nvbugId: <TableCell key={0}>NVBugs ID</TableCell>,
  synopsis: <TableCell key={1}>Synopsis</TableCell>,
  action: <TableCell key={2}>Action</TableCell>
})

const enhanceSource = (onClick) => R.map(({id, nvbugId, synopsis, ...rest}) => ({
  ...rest,
  synopsis,
  nvbugId: <a target="_blank" href={`https://nvbugs/${nvbugId}`}>{nvbugId}</a>,
  action: <ActionButton onClickFunc={() => onClick(id, synopsis)} />
}))

const TableComponent = ({onClick, source, ...rest}) => {
  const props = {
    tableHeadContent, 
    source: enhanceSource(onClick)(source)
  }
  return <Table {...rest}{...props} />
}

export default TableComponent
